export const rules = {
  required: (v) => !!v || (v && !!v.trim()) || 'Missing required value',
};
